import {
  ChangeDetectionStrategy,
  Component,
  effect,
  EventEmitter,
  input,
  Input,
  Output
} from '@angular/core';

import { IconSizes, irisIcon } from '@sondermind/iris/icon';
import { IrisButtonTarget, IrisButtonTypeAttributeOptions, Required } from '@sondermind/iris/shared';

import { IrisIconButtonTypes } from './enums/icon-button-type.enum';

@Component({
  selector: 'iris-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IrisIconButtonComponent {
  private irisIconButtonTypes = IrisIconButtonTypes;

  @Input() @Required ariaLabel!: string;
  @Input() disabled: boolean = false;
  @Input() linkHref: string = '';
  @Input() target: IrisButtonTarget | undefined;
  @Input() iconSize = IconSizes.MD;
  readonly type = input<IrisIconButtonTypes>(this.irisIconButtonTypes.SECONDARY);
  @Input() typeAttribute: IrisButtonTypeAttributeOptions = IrisButtonTypeAttributeOptions.SUBMIT;
  @Input() icon!: irisIcon;

  @Output() click: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  iconButtonClasses: string = '';

  constructor() {
    effect(() => {
      this.iconButtonClasses = `iris-icon-button iris-icon-button--${this.type()}`;
    });
  }

  onClick(event: MouseEvent): void {
    event.stopImmediatePropagation();
    if (!this.disabled) {
      this.click.emit(event);
    }
  }
}
